<template>
  <v-flex>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title>Cuestionario</v-toolbar-title>
        <v-divider class="mx-4" inset vertical />
        <v-spacer />
        <v-btn small depressed :color="colorAccent1" class="white--text" :loading="loading" :disabled="hayCambiosPendientes" @click="cargarPreguntas">
          <v-icon left>mdi-refresh</v-icon>Actualizar
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-0" align="center" dense>
          <v-col cols="12" sm="8">
            <div class="subtitle-1 font-weight-medium">Catálogo de preguntas</div>
            <p class="mb-0">Preguntas por categoría de proveedor y preguntas generales de Rutas Meigas. Valoración del 1 al 10; respuestas y comentarios opcionales.</p>
            <p class="mb-0 mt-1">Pulsa el estado para activar o desactivar una pregunta. Solo las activas aparecen en el cuestionario del cliente.</p>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select v-model="idioma" :dark="dark" :items="idiomas" label="Idioma de las preguntas" outlined dense hide-details />
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-card-text>
        <v-progress-linear v-if="loading" class="my-4" indeterminate :color="colorAccent1" rounded height="6" aria-label="Cargando preguntas" />
        <v-alert v-else-if="error" class="mt-4" type="error" outlined role="alert">
          {{ error }}
          <v-btn text small @click="cargarPreguntas">Reintentar</v-btn>
        </v-alert>
        <template v-else>
          <v-alert v-if="!grupos.length" class="mt-4" type="info" outlined>No hay categorías ni preguntas disponibles.</v-alert>
          <v-card v-for="grupo in grupos" :key="grupo.categoria_proveedor_id === null ? 'empresa' : grupo.categoria_proveedor_id" class="mb-2" color="rgb(250, 250, 250)">
            <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
              <v-chip label small color="rgb(60, 60, 60)" text-color="white">{{ grupo.preguntas.length }} preguntas</v-chip>
              <v-divider class="mx-2" inset vertical />
              <v-toolbar-title>{{ grupo.categoria_proveedor_nombre }}</v-toolbar-title>
              <v-spacer />
              <v-chip label class="mr-2" link :color="colorAccent1" :disabled="hayCambiosPendientes" @click="nuevaPregunta(grupo)">
                <span style="color: white;">Nueva pregunta</span>
              </v-chip>
            </v-toolbar>
            <v-card-text>
            <v-data-table
              locale="es" dense class="elevation-1 alternating-rows bordered-table"
              :headers="headers" :items="grupo.preguntas" item-key="id"
              :items-per-page="-1" hide-default-footer :sort-by="['orden', 'id']" :must-sort="true"
              no-data-text="No hay preguntas configuradas para esta categoría."
            >
              <template v-slot:[`item.titulo`]="{ item }">{{ texto(item, 'titulo') }}</template>
              <template v-slot:[`item.pregunta`]="{ item }">{{ texto(item, 'pregunta') }}</template>
              <template v-slot:[`item.comentario`]="{ item }">
                {{ item.permite_comentario ? texto(item, 'pregunta_comentario') : 'No permite comentarios' }}
              </template>
              <template v-slot:[`item.activa`]="{ item }">
                <v-btn
                  small depressed class="white--text"
                  :color="item.activa ? 'green lighten-1' : 'red lighten-2'"
                  :loading="!!estadosGuardando[item.id]"
                  :disabled="!!estadosGuardando[item.id] || eliminandoId === item.id"
                  :aria-pressed="String(item.activa)"
                  :aria-label="(item.activa ? 'Desactivar pregunta: ' : 'Activar pregunta: ') + texto(item, 'titulo')"
                  @click="cambiarEstado(item)"
                >{{ item.activa ? 'ACTIVA' : 'INACTIVA' }}</v-btn>
              </template>
              <template v-slot:[`item.acciones`]="{ item }">
                <div class="d-flex justify-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip label class="mr-1 px-1" link :color="colorAccent3" :disabled="hayCambiosPendientes" :aria-label="'Editar pregunta: ' + texto(item, 'titulo')" v-bind="attrs" v-on="on" @click="editarPregunta(item, grupo)">
                        <v-icon color="white">mdi-pencil</v-icon>
                      </v-chip>
                    </template>
                    <span>Editar pregunta</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small depressed min-width="28" class="mr-1 px-1" color="red lighten-2" :disabled="!!estadosGuardando[item.id] || eliminandoId === item.id" :aria-label="'Eliminar pregunta: ' + texto(item, 'titulo')" v-bind="attrs" v-on="on" @click="solicitarEliminacion(item)">
                        <v-icon color="white">mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar pregunta</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
            </v-card-text>
          </v-card>
        </template>
      </v-card-text>
    </v-card>
    <v-dialog v-if="modelPregunta" :value="true" max-width="1200" persistent>
      <valoracion-pregunta-formulario
        :model-pregunta="modelPregunta" :categoria-nombre="categoriaFormulario" :accion="accionFormulario"
        @cerrarFormularioPregunta="modelPregunta = null" @preguntaGuardada="preguntaGuardada"
      />
    </v-dialog>
    <v-dialog :value="!!preguntaAEliminar" max-width="500" persistent>
      <v-card color="rgb(250, 250, 250)">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title>Eliminar pregunta</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="preguntaAEliminar" class="pt-5">
          <p>¿Quieres eliminar la pregunta «{{ texto(preguntaAEliminar, 'titulo') }}»?</p>
          <p class="mb-0">Dejará de aparecer en el cuestionario. Las valoraciones recibidas se conservarán.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="eliminandoId !== null" @click="preguntaAEliminar = null">Cancelar</v-btn>
          <v-btn color="red lighten-2" depressed class="white--text" :loading="eliminandoId !== null" :disabled="eliminandoId !== null" @click="eliminarPregunta">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="aviso.visible" :color="aviso.color" :timeout="6000" role="status">
      {{ aviso.texto }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="aviso.visible = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex';
import ValoracionPreguntaFormulario from '@/components/formularios/ValoracionPreguntaFormulario.vue';
import { listarPreguntasValoracion, actualizarEstadoPreguntaValoracion, eliminarPreguntaValoracion } from '@/services/valoraciones';

export default {
  name: 'Valoraciones',
  components: { ValoracionPreguntaFormulario },
  data: () => ({
    grupos: [],
    loading: false,
    error: '',
    estadosGuardando: {},
    preguntaAEliminar: null,
    eliminandoId: null,
    modelPregunta: null,
    categoriaFormulario: '',
    accionFormulario: 'crear',
    aviso: { visible: false, texto: '', color: 'success' },
    idioma: 'ES',
    idiomas: [
      { text: 'Español', value: 'ES' },
      { text: 'English', value: 'EN' },
      { text: 'Deutsch', value: 'DE' },
    ],
    headers: [
      { text: 'Orden', value: 'orden', width: 90 },
      { text: 'Título', value: 'titulo', sortable: false },
      { text: 'Pregunta', value: 'pregunta', sortable: false },
      { text: 'Texto del comentario (opcional)', value: 'comentario', sortable: false },
      { text: 'Estado', value: 'activa', width: 110 },
      { text: 'Acciones', value: 'acciones', sortable: false, align: 'center', width: 100 },
    ],
  }),
  computed: {
    ...mapState(['dark', 'colorBarraFormulario', 'colorAccent1', 'colorAccent3']),
    ...mapState('auth', ['access_token']),
    hayCambiosPendientes() {
      return Object.keys(this.estadosGuardando).length > 0 || this.eliminandoId !== null;
    },
  },
  created() {
    this.cargarPreguntas();
  },
  methods: {
    nuevaPregunta(grupo) {
      if (this.loading || this.hayCambiosPendientes) return;
      const ultimoOrden = grupo.preguntas.reduce((maximo, pregunta) => Math.max(maximo, pregunta.orden), 0);
      this.modelPregunta = { categoria_proveedor_id: grupo.categoria_proveedor_id, orden: Math.min(ultimoOrden + 1, 65535) };
      this.categoriaFormulario = grupo.categoria_proveedor_nombre;
      this.accionFormulario = 'crear';
    },
    editarPregunta(pregunta, grupo) {
      if (this.loading || this.hayCambiosPendientes) return;
      this.modelPregunta = { ...pregunta };
      this.categoriaFormulario = grupo.categoria_proveedor_nombre;
      this.accionFormulario = 'editar';
    },
    async preguntaGuardada() {
      this.modelPregunta = null;
      await this.cargarPreguntas();
    },
    solicitarEliminacion(pregunta) {
      if (this.loading || this.estadosGuardando[pregunta.id] || this.eliminandoId !== null) return;
      this.preguntaAEliminar = pregunta;
    },
    async eliminarPregunta() {
      const pregunta = this.preguntaAEliminar;
      if (!pregunta || this.loading || this.estadosGuardando[pregunta.id] || this.eliminandoId !== null) return;
      this.eliminandoId = pregunta.id;
      try {
        await eliminarPreguntaValoracion(this.access_token, pregunta.id);
        this.grupos.forEach(grupo => {
          grupo.preguntas = grupo.preguntas.filter(item => item.id !== pregunta.id);
        });
        this.preguntaAEliminar = null;
      } catch (error) {
        this.aviso = { visible: true, texto: 'No se pudo eliminar la pregunta. Inténtalo de nuevo.', color: 'error' };
      } finally {
        this.eliminandoId = null;
      }
    },
    async cambiarEstado(pregunta) {
      if (this.loading || this.estadosGuardando[pregunta.id] || this.eliminandoId === pregunta.id) return;
      this.$set(this.estadosGuardando, pregunta.id, true);
      try {
        const actualizada = await actualizarEstadoPreguntaValoracion(this.access_token, pregunta.id, !pregunta.activa);
        pregunta.activa = actualizada.activa;
      } catch (error) {
        this.aviso = { visible: true, texto: 'No se pudo cambiar el estado. Inténtalo de nuevo.', color: 'error' };
      } finally {
        this.$delete(this.estadosGuardando, pregunta.id);
      }
    },
    texto(pregunta, campo) {
      return pregunta[campo + '_' + this.idioma] || 'Sin traducción';
    },
    async cargarPreguntas() {
      if (this.loading || this.hayCambiosPendientes) return;
      this.loading = true;
      this.error = '';
      try {
        this.grupos = await listarPreguntasValoracion(this.access_token);
      } catch (error) {
        this.grupos = [];
        this.error = 'No se pudo cargar el catálogo de preguntas. Inténtalo de nuevo.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.alternating-rows ::v-deep tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}

.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th,
.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  overflow-wrap: anywhere;
}
</style>
